module.exports = __webpack_public_path__ + "static/wtf2-9f11179e75145d446df966d616e7470b.gif";